export default __webpack_public_path__ + "static/media/cultlogo.03ffb164.svg";